import React, { useState, useEffect } from "react";
import TeamService from "services/TeamService";
import Loader from "components/Loader";
import Comment from "./Comment";
import CreateComment from "./CreateComment";
import { ExpressionsContext } from "store/contexts/expressionsContext";
import Button from "components/CustomButton";
import { useUserContext } from "store/contexts/userContext";
import { useTopicContext } from "store/contexts/topicContext";

export default ({ post }) => {
  const [expressions, setExpressions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [meta, setMeta] = useState({});
  const [page, setPage] = useState(1);
  const { updateTopic } = useTopicContext();
  const { user } = useUserContext();

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      try {
        const response = await TeamService.getExpressionList(
          post.team_id,
          post.id,
          { page: page }
        );

        setIsLoading(false);
        setMeta(response.data.meta);
        setExpressions(
          Array.from(new Set([...expressions, ...response.data.data]))
        );
      } catch (e) {
        console.log(e);
      }
    })();

    // eslint-disable-next-line
  }, [post.id, post.team_id, page]);

  const createExpression = (expression) => {
    setExpressions(Array.from(new Set([expression, ...expressions])));
  };

  const deleteExpression = (newExpression) => {
    var newExpressions = expressions.filter(
      (expressions) => expressions.id !== newExpression.id
    );

    var userExpressionExist = newExpressions.some(
      (expression) => expression?.user?.id === user?.id
    );

    if (!userExpressionExist) {
      const postCopy = { ...post };

      postCopy.expressions_count -= 1;
      postCopy.user_expressed = false;

      updateTopic(postCopy);
    }

    setExpressions(newExpressions);
  };

  const updateExpression = (expression) => {
    const expressionsCopy = [...expressions];

    expressionsCopy[
      expressionsCopy.findIndex((tExpression) => {
        return tExpression.id === expression.id;
      })
    ] = {
      ...expression,
    };

    setExpressions(expressionsCopy);
  };

  return (
    <ExpressionsContext.Provider
      value={{
        createExpression,
        deleteExpression,
        updateExpression,
      }}
    >
      <div className="post_comments-section">
        <CreateComment post={post} />
        <div>
          {expressions.map((expression) => (
            <Comment expression={expression} key={expression.id} post={post} />
          ))}
          {page !== meta?.last_page && !isLoading && (
            <div className="viewAllButton">
              <Button
                buttonClass={"grad_btn join-btn"}
                onClick={() => setPage(page + 1)}
              >
                Load More
              </Button>
            </div>
          )}
          {isLoading && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Loader />
            </div>
          )}
        </div>
      </div>
    </ExpressionsContext.Provider>
  );
};
